<template>
  <div></div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
  CHAT_BODY_SCROLL_TO_BOTTOM,
  CHAT_CHECK_FAILED_MESSAGES,
  CHAT_SEND_MESSAGE,
  CHAT_SEND_MESSAGE_RETRY,
} from '@/eventTypes';
import EventBus from '@/eventBus';
import newMessageGql from '@/graphql/mutations/sendMessage.gql';

export default {
  computed: {
    ...mapState([
      'failedMessages',
    ]),
  },
  created() {
    EventBus.$on(CHAT_SEND_MESSAGE, (message, fromHistory = false) => {
      this.sendMessage(message, fromHistory);
    });

    EventBus.$on(CHAT_SEND_MESSAGE_RETRY, (message) => {
      this.retrySendMessage(message);
    });

    EventBus.$on(CHAT_CHECK_FAILED_MESSAGES, () => {
      this.checkForFailedJobs();
    });
  },
  destroyed() {
    EventBus.$off(CHAT_SEND_MESSAGE);
    EventBus.$off(CHAT_SEND_MESSAGE_RETRY);
    EventBus.$off(CHAT_CHECK_FAILED_MESSAGES);
  },
  methods: {
    ...mapMutations([
      'addMessageToConversation',
      'addFailedMessage',
      'startFailedMessageJob',
      'deleteFailedMessageJob',
    ]),
    async sendMessage(message, fromHistory) {
      this.addMessageToConversation({
        clientId: message.clientId,
        message,
        fromHistory,
      });

      EventBus.$emit(CHAT_BODY_SCROLL_TO_BOTTOM);

      await this.doSendMessage(message);
    },
    async retrySendMessage(message) {
      await this.doSendMessage(message);
    },
    async doSendMessage(message) {
      await this.$apollo.mutate({
        mutation: newMessageGql,
        variables: message,
      }).then(() => {
        this.deleteFailedMessageJob(message.tempId);
      }).catch(() => {
        this.addFailedMessage(message);
        throw new Error();
      });
    },
    checkForFailedJobs() {
      this.failedMessages.forEach((data) => {
        if (data.status === 'pending') {
          this.startFailedMessageJob(data.id);
        }
      });
    },
  },
};
</script>
